/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ProviderCard from '@/model/ProviderCard'

class PriceComparison {
  private json: any
  public readonly title: string;
  public readonly description: string;
  public readonly plusProviderCard: ProviderCard;
  public readonly nonPlusProviderCard: ProviderCard;

  constructor (json: any) {
    this.title = json.price_comparison
    this.description = json.promotion_text
    this.plusProviderCard = ProviderCard.of(json, true)
    this.nonPlusProviderCard = ProviderCard.of(json, false)
  }

  static of (json: any): PriceComparison {
    return new PriceComparison(json)
  }
}

export default PriceComparison
